/** Backend `HtsChatCarriedFrom` — where a conversation shown on a line was actually held (entry history, #13385). */
export enum enumHtsChatCarriedFrom {
  Catalog = 1,
  DuplicatedEntry = 2,
  CompanyHistory = 3,
  SimilarProduct = 4,
}
